<ng-container>
    <p-floatlabel variant="over">
        <input type="text" id="inputtext" pInputText [(ngModel)]="value" (ngModelChange)="onChangeValue($event)" autofocus>
        <label for="inputtext">{{label}}</label>
    </p-floatlabel>
</ng-container>
